/** Shared modal header + close button layout (matches admin Course Builder filters). */
export const MODAL_HEADER_LAYOUT_CLASS =
	"flex items-center justify-between gap-3 min-h-[5rem] flex-shrink-0";

export const MODAL_HEADER_SURFACE_CLASS = "bg-primary text-white px-5 py-5 shrink-0";

export const MODAL_TITLE_CLASS = "text-lg font-semibold text-white leading-snug sm:text-xl";

export const MODAL_CLOSE_BUTTON_CLASS =
	"inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-black/10 bg-[#f3f3f3] text-[#161616] shadow-[0_1px_2px_rgba(15,23,42,0.08)] transition-colors hover:bg-white hover:border-black/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50";

export const MODAL_FOOTER_PADDING_WHEN_ZERO_BODY = "px-5 pb-5 sm:px-6 sm:pb-6 pt-0";
